// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dae7a52d","453":"f381c696","667":"08afb540"}[chunkId] + ".chunk.js";
};